const scope = {
    name_exists: 'نام scope {{name}} از قبل در حال استفاده است',
    name_with_space: 'نام scope نمی‌تواند شامل فاصله باشد.',
};
export default Object.freeze(scope);
